import { Link, useLocation } from 'react-router-dom';
import { MessageCircleIcon } from 'lucide-react';
import { legalByPath, legalDocs } from '../../data/legal';
import { founder, salon } from '../../data/content';
import { NotFound } from '../layout/NotFound';
import { shopLabels } from '../../data/shopLabels';
import { btnPrimary } from '../../ui/styles';

/** Eén template voor privacy, voorwaarden en verzending & retour. */
export function Legal() {
  const {
    pathname
  } = useLocation();
  const doc = legalByPath(pathname) ?? legalDocs[0];

  // Alleen als er in het geheel geen juridische teksten zijn (lege backend).
  if (!doc) return <NotFound data-id="element-7974" data-mp="2w18kuyahvb3" />;
  return <section className="bg-sand" data-id="element-7975" data-mp="2uq6czkhsvm3">
      <div className="mx-auto grid max-w-content gap-12 px-6 pb-24 pt-12 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:pt-16" data-id="element-7976" data-mp="7uclxfnsmny2">
        {/* min-w-0: een grid-kind is standaard minstens zo breed als zijn scrollrijtje; zonder dit loopt de kolom buiten beeld. */}
        <nav aria-label="Klantenservice" className="min-w-0 lg:col-span-3" data-id="element-7977" data-mp="10bf6motsnptd">
          <ul className="flex gap-2 overflow-x-auto [scrollbar-width:none] lg:sticky lg:top-32 lg:flex-col lg:gap-0 lg:border-l lg:border-line" data-id="element-7978" data-mp="1zdmoevf9qwbb">
            {legalDocs.map(d => {
            const active = d.path === doc.path;
            return <li key={d.path} data-id="element-7979" data-mp="29625zrmnlivo">
                  <Link to={d.path} aria-current={active ? 'page' : undefined} className={`block whitespace-nowrap rounded-full border px-4 py-2.5 text-[14px] transition-colors duration-150 ease-soft lg:-ml-px lg:rounded-none lg:border-0 lg:border-l lg:px-5 lg:py-2.5 ${active ? 'border-ink bg-ink text-shell lg:border-clay lg:bg-transparent lg:text-ink' : 'border-line text-muted hover:text-ink lg:border-transparent'}`} data-id="element-7980" data-mp="24d8zozbje2hh">
                    {d.title}
                  </Link>
                </li>;
          })}
          </ul>
        </nav>

        <article className="min-w-0 max-w-[680px] lg:col-span-8 lg:col-start-5" data-id="element-7981" data-mp="1ie4pqdi44m9k">
          <h1 className="font-display text-[2.6rem] font-light leading-[1.05] text-ink sm:text-5xl" data-id="element-7982" data-mp="1ighdx8egrsv2">{doc.title}</h1>
          <p className="mt-3 text-[14px] text-muted" data-id="element-7983" data-mp="1ret4jafbyqni">Laatst bijgewerkt: {doc.updated}</p>
          <p className="mt-8 text-[17px] leading-relaxed text-ink" data-id="element-7984" data-mp="1rh5pzxkarj5b">{doc.intro}</p>

          <div className="mt-12 space-y-10" data-id="element-7985" data-mp="1wbt73bcz1b9v">
            {doc.sections.map(s => <section key={s.heading} id={s.id} className="scroll-mt-32 border-t border-line pt-8" data-id="element-7986" data-mp="21cqohlq5q1ab">
                <h2 className="font-display text-2xl font-light text-ink" data-id="element-7987" data-mp="25crfe5ug04y9">{s.heading}</h2>
                {s.body.map((p, i) =>
            // Alinea's zijn vaste tekst zonder id; twee gelijke alinea's mogen niet botsen.
            <p key={`${i}-${p.slice(0, 24)}`} className="mt-4 text-[16px] leading-relaxed text-muted" data-id="element-7988" data-mp="2k3gu3i74426v" data-mpi={i}>
                    {p}
                  </p>)}
              </section>)}
          </div>

          <div className="mt-14 flex flex-col gap-4 bg-shell p-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-7989" data-mp="dfht7lfn4dh0">
            <p className="text-[15px] leading-relaxed text-muted" data-id="element-7990" data-mp="8f3n48xlndlm">Vraag die hier niet tussen staat? {founder.firstName} helpt je persoonlijk.</p>
            <a href={salon.whatsapp} target="_blank" rel="noreferrer" className={`${btnPrimary} shrink-0`} data-id="element-7991" data-mp="3iv8qxr87ofi">
              <MessageCircleIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-7992" data-mp="w5pqvo0kmbpt" />
              Stuur een bericht
              <span className="sr-only" data-id="element-7993" data-mp="r6368tiext6z">
                {' '}
                via WhatsApp aan {founder.firstName} {shopLabels.newTab}
              </span>
            </a>
          </div>
        </article>
      </div>
    </section>;
}